import { watch } from "vue";
import LoginStatusMixin from "@/store/modules/moduleLoginStatus/mixin/LoginStatusMixin";

export default {
  mixins: [LoginStatusMixin],
  data() {
    return {
      CONSTANTS: {
        ACTION_BAR_REF: "NutActionBarRef",
        TAB_BAR_REF: "NutTabBarRef",
        TAB_REF: "NutTabRef",
        PULL_REFRESH_REF: "NutPullRefreshRef",
        BT_BOX_REF: "NutBtBoxRef",
        ALL_SELECT_REF: "NutAllSelectRef",
      },
      WINDOW_CONFIG: {
        actionBarHeight: 0,
        topStickyHeight: 0,
        contentHeight: 0,
        tabBarHeight: 0,
        tabHeight: 0,
        btBoxHeight: 0,
        allSelectHeight: 0,
      },
      PageHeight: window.innerHeight,
    };
  },
  mounted() {
    let actionBarRef = this.$refs[this.CONSTANTS.ACTION_BAR_REF]
    if (
      actionBarRef &&
      typeof actionBarRef.registerChangeListener === "function"
    ) {
      actionBarRef.registerChangeListener(() => {
        this.$refreshHeight();
      })
    }
    this.$refreshHeight();
  },
  updated() {
    this.$refreshHeight();
  },
  methods: {
    $pullRefresh() {
      let pullRefreshRef = this.$refs[this.CONSTANTS.PULL_REFRESH_REF];
      if (pullRefreshRef !== undefined) {
        pullRefreshRef.refresh();
        return;
      }
      console.error("请先定义下拉刷新的ref");
    },
    $refreshHeight() {
      let actionBarRef = this.$refs[this.CONSTANTS.ACTION_BAR_REF];
      if (actionBarRef !== undefined) {
        this.WINDOW_CONFIG.actionBarHeight = actionBarRef.actionBarHeight;
        this.WINDOW_CONFIG.topStickyHeight = actionBarRef.topStickyHeight;
      }
      let tabBarRef = this.$refs[this.CONSTANTS.TAB_BAR_REF];
      if (tabBarRef !== undefined) {
        this.WINDOW_CONFIG.tabBarHeight = tabBarRef.$el.clientHeight;
      }
      let tabRef = this.$refs[this.CONSTANTS.TAB_REF];
      if (tabRef !== undefined) {
        // this.WINDOW_CONFIG.tabHeight = tabRef.$el.clientHeight;
        // 获取 van-tabs 内部标签栏元素的高度，而不是整个组件的高度
        let tabWrap = tabRef.$el.querySelector('.van-tabs__wrap');
        this.WINDOW_CONFIG.tabHeight = tabWrap ? tabWrap.clientHeight : 0;
      }
      let btBoxRef = this.$refs[this.CONSTANTS.BT_BOX_REF];
      if (btBoxRef !== undefined) {
        let btBoxStyle = getComputedStyle(btBoxRef);
        // 安全区底部padding已在PageHeight中扣除，这里需从高度中减去，避免重复计算
        this.WINDOW_CONFIG.btBoxHeight =
          btBoxRef.offsetHeight - parseFloat(btBoxStyle.paddingBottom);
      }
      let element = document.querySelector(".is-ios-safe-area");
      if (element && this.PageHeight == window.innerHeight) {
        this.PageHeight =
          window.innerHeight -
          parseFloat(
            getComputedStyle(element)
              .getPropertyValue("padding-bottom")
              .trim()
              .replace("px", ""),
          );
      }
      this.WINDOW_CONFIG.contentHeight =
        this.PageHeight -
        this.WINDOW_CONFIG.topStickyHeight -
        this.WINDOW_CONFIG.tabHeight -
        this.WINDOW_CONFIG.btBoxHeight -
        this.WINDOW_CONFIG.tabBarHeight;
    },
    $hideStatusBar(show) {
      this.$nw.windowConfig({
        params: {
          hideStatusBar: show,
        },
        success() { },
      });
    },
  },
};
